import { Reducer } from 'redux';
import { UserProfileState, UserProfileTypes } from './types';

export const INITIAL_STATE: UserProfileState = {
  userProfileData: {
    id: '',
    status: 0,
    data: '',
    expiresAt: '',
    createdAt: '',
    updatedAt: '',
    profileId: '',
    Profile: {
      id: '',
      name: '',
    },
    userId: '',
    UserProfileRequest: {
      id: '',
      type: 0,
      createdAt: '',
      updatedAt: '',
      userProfileId: '',
      UserProfileRequestHistories: [],
    },
  },
  userProfileList: [],
  userProfileListRequest: [],
  userProfileListAvailable: [],
  userProfileAttachmentList: {
    photoUrl: '',
    publicPhotoUrl: '',
  },
  chipsList: [],
  documentsList: [],
  userProfileListImportsData: [],
  currentCard: 1,
  totalCount: 0,
  error: false,
  statusLoading: false,
  loading: false,
};

const reducer: Reducer<UserProfileState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST USERPROFILE
    case UserProfileTypes.LIST_USERPROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileList: INITIAL_STATE.userProfileList,
      };
    case UserProfileTypes.LIST_USERPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileList: action.payload.userProfileList,
      };
    case UserProfileTypes.LIST_USERPROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userProfileList: INITIAL_STATE.userProfileList,
      };

    // CASES LIST USERPROFILE REQUEST
    case UserProfileTypes.LIST_USERPROFILE_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
        statusLoading: true,
        error: false,
        userProfileListRequest: INITIAL_STATE.userProfileListRequest,
      };
    case UserProfileTypes.LIST_USERPROFILE_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        statusLoading: false,
        error: false,
        userProfileListRequest: action.payload.userProfileListRequest,
        totalCount: action.payload.totalCount,
      };
    case UserProfileTypes.LIST_USERPROFILE_REQUESTS_FAILURE:
      return {
        ...state,
        loading: false,
        statusLoading: false,
        error: true,
        userProfileListRequest: INITIAL_STATE.userProfileListRequest,
      };

    // CASES LIST USERPROFILE AVAILABLE
    case UserProfileTypes.LIST_USERPROFILE_AVAILABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileListAvailable: INITIAL_STATE.userProfileListAvailable,
      };
    case UserProfileTypes.LIST_USERPROFILE_AVAILABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileListAvailable: action.payload.userProfileListAvailable,
      };
    case UserProfileTypes.LIST_USERPROFILE_AVAILABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userProfileListAvailable: INITIAL_STATE.userProfileListAvailable,
      };

    // CASES UPDATE USERPROFILE
    case UserProfileTypes.UPDATE_USERPROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileData: INITIAL_STATE.userProfileData,
      };
    case UserProfileTypes.UPDATE_USERPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileData: action.payload.userProfileData,
      };
    case UserProfileTypes.UPDATE_USERPROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userProfileData: INITIAL_STATE.userProfileData,
      };

    // CASES REQUEST USERPROFILE
    case UserProfileTypes.REQUEST_USERPROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileData: INITIAL_STATE.userProfileData,
      };
    case UserProfileTypes.REQUEST_USERPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileData: action.payload.userProfileData,
      };
    case UserProfileTypes.REQUEST_USERPROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userProfileData: INITIAL_STATE.userProfileData,
      };

    // CASES UPDATE USERPROFILE DATA
    case UserProfileTypes.UPDATE_USERPROFILE_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileData: INITIAL_STATE.userProfileData,
      };
    case UserProfileTypes.UPDATE_USERPROFILE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileData: action.payload.userProfileData,
      };
    case UserProfileTypes.UPDATE_USERPROFILE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userProfileData: INITIAL_STATE.userProfileData,
      };

    // CASES REQUEST USERPROFILE ATTACHMENT
    case UserProfileTypes.REQUEST_USERPROFILE_ATTACHMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileAttachmentList: INITIAL_STATE.userProfileAttachmentList,
      };
    case UserProfileTypes.REQUEST_USERPROFILE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileAttachmentList: action.payload.userProfileAttachmentList,
      };
    case UserProfileTypes.REQUEST_USERPROFILE_ATTACHMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userProfileAttachmentList: INITIAL_STATE.userProfileAttachmentList,
      };

    // CASES UPDATE USERPROFILE STATUS
    case UserProfileTypes.UPDATE_USERPROFILE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileData: INITIAL_STATE.userProfileData,
      };
    case UserProfileTypes.UPDATE_USERPROFILE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileData: action.payload.userProfileData,
      };
    case UserProfileTypes.UPDATE_USERPROFILE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userProfileData: INITIAL_STATE.userProfileData,
      };

    // CASES UPDATE USERPROFILE REQUESTS
    case UserProfileTypes.UPDATE_USERPROFILE_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileData: INITIAL_STATE.userProfileData,
      };
    case UserProfileTypes.UPDATE_USERPROFILE_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileData: action.payload.userProfileData,
      };
    case UserProfileTypes.UPDATE_USERPROFILE_REQUESTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userProfileData: INITIAL_STATE.userProfileData,
      };

    // CASES UPDATE USERPROFILE EXPIRATION
    case UserProfileTypes.REQUEST_USERPROFILE_EXPIRATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UserProfileTypes.REQUEST_USERPROFILE_EXPIRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case UserProfileTypes.REQUEST_USERPROFILE_EXPIRATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASE DOCUMENTS LIST
    case UserProfileTypes.DOCUMENTS_LIST:
      return {
        ...state,
        loading: false,
        error: false,
        documentsList: action.payload.documentsList,
      };

    // CASE CURRENT CARD
    case UserProfileTypes.CURRENT_CARD:
      return {
        ...state,
        loading: false,
        error: false,
        currentCard: action.payload.cardIndex,
      };

    // CASES GET CHIPS
    case UserProfileTypes.CREATE_CHIPS_LIST:
      return {
        ...state,
        loading: false,
        error: false,
        chipsList: action.payload.chipsList,
      };

    // CASES CLEAR CHIPS
    case UserProfileTypes.CLEAN_CHIPS_LIST:
      return {
        ...state,
        loading: false,
        error: false,
        chipsList: INITIAL_STATE.chipsList,
      };

    // CASES USER PROFILE LIST IMPORTS REQUEST
    case UserProfileTypes.USER_PROFILE_LIST_IMPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userProfileListImportsData: INITIAL_STATE.userProfileListImportsData,
      };
    case UserProfileTypes.USER_PROFILE_LIST_IMPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userProfileListImportsData: action.payload.userProfileListImportsData,
      };
    case UserProfileTypes.USER_PROFILE_LIST_IMPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CHARGE REQUEST PAY
    case UserProfileTypes.USER_PROFILE_IMPORT_REQUEST:
      return { ...state, loading: true, error: false };
    case UserProfileTypes.USER_PROFILE_IMPORT_SUCCESS:
      return { ...state, loading: false, error: false };
    case UserProfileTypes.USER_PROFILE_IMPORT_FAILURE:
      return { ...state, loading: false, error: false };

    default:
      return state;
  }
};

export default reducer;
